(function() {
    "use strict";

    angular.module("dashboardApp").directive("imsFooter", Directive);

    Directive.$inject = [
        'AppSettings'
    ];



    function Directive (
        AppSettings
    ) {


        function link($scope, element) {

            //$scope.year = new Date().getFullYear();

        }



        return {
            restrict: 'E',
            replace: true,
            scope: {
            },
            templateUrl: AppSettings.paths.html + '/common/layout/footer.template.html',
            link: link
        };



    }


})();
